import { useCurrentStaffId, useServerEvent } from '@maxtropy/components';
import { useEffect, useState } from 'react';

interface GasSchedulePendingConfirmPushMessage {
  pendingCount: number;
}

export function useGasSchedulePendingConfirmRefresh() {
  const currentStaffId = useCurrentStaffId();
  const [destination, setDestination] = useState<string>();
  const [pendingConfirmCount, setPendingConfirmCount] = useState(0);

  useEffect(() => {
    if (currentStaffId) {
      setDestination(`/ws/confirm-order/staff/${currentStaffId}`);
    }
  }, [currentStaffId]);

  const pushMessage = useServerEvent<GasSchedulePendingConfirmPushMessage>(destination);

  useEffect(() => {
    if (pushMessage?.pendingCount === undefined) {
      return;
    }

    setPendingConfirmCount(pushMessage.pendingCount);
  }, [pushMessage]);

  return pendingConfirmCount;
}
